module.exports = __webpack_public_path__ + "site/img/28.db588c78.jpg";